/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_ReactivateInputs */

const fr_rapid_eager_otter_reactivate = /** @type {(inputs: Rapid_Eager_Otter_ReactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En réactivant votre abonnement, vous continuerez à être facturé selon les conditions initiales et votre abonnement ne sera plus annulé à la fin de la période en cours.`)
};

/**

* @param {Rapid_Eager_Otter_ReactivateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_reactivate = /** @type {((inputs?: Rapid_Eager_Otter_ReactivateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_ReactivateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_reactivate(inputs)
});